var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroccery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_4118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8059 8.24746V2.4418C25.8059 1.98154 25.4327 1.6084 24.9725 1.6084H21.0698C20.6096 1.6084 20.2364 1.98154 20.2364 2.4418V8.24736C20.2364 8.58184 20.1028 8.90254 19.8652 9.13809L17.135 11.8455C16.8117 12.166 16.6299 12.6023 16.6299 13.0575V29.7413H29.4124V13.0576C29.4124 12.6024 29.2306 12.1661 28.9073 11.8456L26.1771 9.13818C25.9395 8.90264 25.8059 8.58193 25.8059 8.24746Z",
    fill: "#8D9CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9075 11.8456L26.1772 9.13818C25.9397 8.90264 25.8061 8.58203 25.8061 8.24746V2.4418C25.8061 1.98154 25.4329 1.6084 24.9727 1.6084H22.4336C22.8939 1.6084 23.267 1.98154 23.267 2.4418V8.8333C23.267 9.16787 23.4006 9.48848 23.6382 9.72402L26.3685 12.4314C26.6917 12.752 26.8735 13.1883 26.8735 13.6435V29.7413H29.4126V13.0576C29.4126 12.6024 29.2308 12.1661 28.9075 11.8456Z",
    fill: "#7A8C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8058 7.22129V2.4418C25.8058 1.98154 25.4326 1.6084 24.9724 1.6084H21.0697C20.6095 1.6084 20.2363 1.98154 20.2363 2.4418V7.22119L25.8058 7.22129Z",
    fill: "#FD8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.267 2.4418V7.22119H25.8061V2.4418C25.8061 1.98154 25.4329 1.6084 24.9727 1.6084H22.4336C22.8938 1.6084 23.267 1.98154 23.267 2.4418Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12481 16.6101L8.59258 15.5324C8.95156 11.5943 7.33682 7.74327 4.29824 5.23898C4.11299 5.08634 3.85713 5.05148 3.63711 5.14747L2.1584 5.79318C1.87158 5.91847 1.81553 6.29904 2.05215 6.50392C4.94737 9.01056 6.475 12.7689 6.12481 16.6101Z",
    fill: "#68CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8717 16.6101L9.40388 15.5324C9.0449 11.5943 10.6596 7.74327 13.6982 5.23898C13.8835 5.08634 14.1393 5.05148 14.3594 5.14747L15.838 5.79318C16.1248 5.91847 16.1808 6.29904 15.9442 6.50392C13.0492 9.01056 11.5215 12.7689 11.8717 16.6101Z",
    fill: "#68CA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 14.3918H10.3451V3.56465C10.3451 3.19297 10.0437 2.8916 9.67207 2.8916H8.32539C7.95371 2.8916 7.65234 3.19297 7.65234 3.56465V14.3918Z",
    fill: "#97DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99834 32.5331C11.0496 32.5331 13.7184 20.1208 13.7184 15.1714C13.7184 12.5958 11.5739 10.5078 8.99834 10.5078C6.42275 10.5078 4.27832 12.5957 4.27832 15.1714C4.27832 20.1209 6.94717 32.5331 8.99834 32.5331Z",
    fill: "#FE9738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22363 15.3037V44.4696C2.22363 44.9839 2.64053 45.4008 3.15479 45.4008H31.1115C31.6258 45.4008 32.0427 44.9839 32.0427 44.4696V15.3037C32.0427 14.7895 31.6258 14.3726 31.1115 14.3726H3.15479C2.64053 14.3726 2.22363 14.7895 2.22363 15.3037Z",
    fill: "#E19974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1113 14.3726H28.4746C28.9889 14.3726 29.4058 14.7895 29.4058 15.3037V44.4696C29.4058 44.9839 28.9889 45.4008 28.4746 45.4008H31.1113C31.6256 45.4008 32.0425 44.9839 32.0425 44.4696V15.3037C32.0425 14.7895 31.6256 14.3726 31.1113 14.3726Z",
    fill: "#DC8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.959 25.5603V48.1685C27.959 49.2593 28.8433 50.1436 29.9341 50.1436H47.1317C48.2226 50.1436 49.1068 49.2593 49.1068 48.1685V25.5603H27.959Z",
    fill: "#FEF1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4702 25.5603V48.1685C46.4702 49.2593 45.5859 50.1436 44.4951 50.1436H47.1318C48.2227 50.1436 49.1069 49.2593 49.1069 48.1685V25.5603H46.4702Z",
    fill: "#FAE2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.959 25.5604V21.8552C27.959 21.3098 28.4011 20.8677 28.9465 20.8677H48.1192C48.6646 20.8677 49.1067 21.3098 49.1067 21.8552V25.5604H27.959Z",
    fill: "#FD8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1191 20.8677H45.4824C46.0278 20.8677 46.4699 21.3098 46.4699 21.8552V25.5604H49.1066V21.8552C49.1067 21.3099 48.6646 20.8677 48.1191 20.8677Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 29.3154C32.8419 29.3154 32.209 29.9483 32.209 30.729C32.209 31.5097 32.8419 32.1426 33.6226 32.1426C34.4032 32.1426 35.0361 31.5098 35.0361 30.729C35.0361 29.9483 34.4033 29.3154 33.6226 29.3154Z",
    fill: "#97DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 36.1665C32.8419 36.1665 32.209 36.7994 32.209 37.5801C32.209 38.3607 32.8419 38.9937 33.6226 38.9937C34.4032 38.9937 35.0361 38.3608 35.0361 37.5801C35.0361 36.7993 34.4033 36.1665 33.6226 36.1665Z",
    fill: "#97DA7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 43.0176C32.8419 43.0176 32.209 43.6505 32.209 44.4312C32.209 45.2118 32.8419 45.8447 33.6226 45.8447C34.4032 45.8447 35.0361 45.2119 35.0361 44.4312C35.0361 43.6505 34.4033 43.0176 33.6226 43.0176Z",
    fill: "#97DA7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_4118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.505859 0.875977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroccery);
export default __webpack_public_path__ + "static/media/groccery.fa012a29bbd75873f060f4ef7ec4174d.svg";
export { ForwardRef as ReactComponent };